// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "6e356252f6e95e5c01f0" + ".js";
};